/**
 * This is the establishMemword controller.
 * @memberOf establishMemword Module
 * @namespace establishMemword Controller
 */

/**
 * @name establishMemwordController
 * @desc Create the controller.
 * @param $scope
 * @param $http
 * @param coreService
 * @param establishMemwordService
 * @memberOf establishMemword Module.establishMemword Controller
 * @ngInject
 */
function establishMemwordController($scope, $translate, coreService, establishMemwordService, $log) {

 
    // Assign this controller as the view-model.
    // It will be accessible as 'establishMemwordService' within the HTML template.
    var vm = this;

    // Register the view model's properties.
    vm.validateForm = validateForm;
    vm.submitted = false;
   
    vm.messages = [];

    vm.hideReminder = true;
  
    // Activate the controller.
    activate();


 
    // Activates the controller.
    function activate() {

        // Read Identity Server's data model
		var model = coreService.getIdentityModel();

		// Change display language
		if (model.custom && model.custom.ui_locales) {
			$translate.use(model.custom.ui_locales);
		}

		// Display error returned by Identity Server
		if (model.errorMessage) {
			$log.error(model.errorMessage);
			vm.messages.push(model.errorMessage);
		}

        // Set default loginUrl if not set in the model
        if (!model.loginUrl) {
            model.loginUrl = '/login/memword?signin=';
        }

		// Auto redirect
		if (model.autoRedirect && model.redirectUrl) {
			if (model.autoRedirectDelay <= 0) {
                // Workaround: FF crashes if redirect timeout is set to 0
                var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
                if (isFirefox) {
                    model.autoRedirectDelay = 0.1;
                }
                else {
                    model.autoRedirectDelay = 0;
                }
			}
			window.setTimeout(function () {
				window.location = model.redirectUrl;
			}, model.autoRedirectDelay * 1000);
		}

        $scope.model = model;
       
    }

    // Validate the login account form.
    function validateForm(e) {
		// Update the form.
		vm.messages = [];
		vm.submitted = true;
		$scope.establishMemwordForm.$dirty = true;
		$scope.establishMemwordForm.$pristine = false;

		if ($scope.establishMemwordForm.$invalid) {
			// Do not submit
			e.preventDefault();
		}
    }
}

export default establishMemwordController;



// WEBPACK FOOTER //
// ./src/login/establishmemword/establishmemword.controller.js